<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input
          v-model="entrustIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入委托商名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>起始港口：</p>
        <el-input
          v-model="portIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入委托商名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>交车港口：</p>
        <el-input
          v-model="endport"
          size="mini"
          style="width: 150px"
          placeholder="请输入委托商名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>适配车型：</p>
        <el-input
          v-model="modelIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入适配车型" />
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select
          v-model="stateIpt"
          filterable
          size="mini"
          style="width: 150px"
          placeholder="请选择状态">
          <el-option
            v-for="item in stateOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>录入人员：</p>
        <el-input
          v-model="createByName"
          size="mini"
          style="width: 150px"
          placeholder="请输入录入人员" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
        <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
        <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div style="display: flex; justify-content: flex-end">
          <span class="el-icon-download el-icon--right table-btn" @click="download">模板下载</span>
          <span style="cursor: pointer">
            <el-upload
              ref="upload"
              class="upload-demo"
              style="color: rgba(51, 136, 255, 1)"
              :action="uploadUrl"
              :auto-upload="true"
              :show-file-list="false"
              :data="uploadData"
              :on-success="planOnSuccess"
              :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
          <span @click="exportData" class="el-icon--right table-btn">导出数据</span>
        </div>
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          row-key="id"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <!-- :selectable="row => { return row.status === 0 }" -->
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column
            prop="customerName"
            label="委托商"
            min-width="150"
            show-overflow-tooltip
            align="center" />
          <el-table-column prop="startPort" label="起始港" align="center" />
          <el-table-column prop="endPort" label="交车港" align="center" />
          <el-table-column
            prop="customerCarName"
            label="适配车型"
            min-width="150"
            show-overflow-tooltip
            align="center" />
          <el-table-column prop="isLoading" label="装车费" align="center">
            <div slot-scope="scope">{{ scope.row.isLoading == 0 ? '有' : '无' }}</div>
          </el-table-column>
          <el-table-column
            prop="isLoadSettlement"
            label="装车费单独结算"
            min-width="100"
            align="center">
            <div slot-scope="scope">
              {{ scope.row.isLoadSettlement == 1 ? '是' : scope.row.isLoading == 1 ? '--' : '否' }}
            </div>
          </el-table-column>
          <el-table-column prop="unloadPrice" label="卸车费" align="center">
            <div slot-scope="scope">{{ scope.row.isUnload == 0 ? '有' : '无' }}</div>
          </el-table-column>
          <el-table-column
            prop="isUnloadSettlement;"
            label="卸车费单独结算"
            min-width="100"
            align="center">
            <div slot-scope="scope">
              {{ scope.row.isUnloadSettlement == 1 ? '是' : scope.row.isUnload == 1 ? '--' : '否' }}
            </div>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            show-overflow-tooltip
            width="150"
            align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="createByName"
            label="录入人员"
            show-overflow-tooltip
            width="150"
            align="center" />
          <el-table-column prop="startDate" label="有效起始" min-width="150" align="center" />
          <el-table-column prop="endDate" label="结束时间" min-width="150" align="center" />
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; padding-left: 10px">
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.id)"
                  >详情
                </el-button>
                <el-button
                  v-if="scope.row.status == 0 || scope.row.status == 1"
                  size="mini"
                  class="yellow-bg"
                  :loading="scope.row.changeLoad"
                  type="primary"
                  @click="changeClick(scope.row.id, scope.row.status,scope.row)">
                  {{ scope.row.status == 0 ? '修改' : '修改车型' }}
                </el-button>
                <el-button
                  v-if="scope.row.status == 0"
                  size="mini"
                  type="primary"
                  @click="enableClick(scope.row)"
                  >启用
                </el-button>
                <el-button
                  v-if="scope.row.status == 1"
                  size="mini"
                  type="danger"
                  @click="disableClick(scope.row)"
                  >停用
                </el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row)">删除 </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="700px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">委托商：</span>
              <span>{{ detailData.customerName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">线路：</span>
              <span>{{ detailData.lineName }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">起始地：</span>
                <span>{{ detailData.startAddressName }}【{{ detailData.startPort }}】</span>
              </div>
              <div>
                <span class="span1">终止地：</span>
                <span>{{ detailData.endAddressName }}【{{ detailData.endPort }}】</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">有效期始：</span>
                <span>{{ detailData.startDate }}</span>
              </div>
              <div>
                <span class="span1">结束时间：</span>
                <span>{{ detailData.endDate }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">装车费：</span>
              <span style="padding-right: 10px">{{ detailData.isLoading == 0 ? '有' : '无' }}</span>
              <span v-if="detailData.isLoadSettlement == 1" style="padding-right: 10px"
                >单独结算</span
              >
              <span v-else style="padding-right: 10px">不单独结算</span>
              <span v-if="detailData.isLoadSettlement == 1" style="padding-right: 10px">
                税率：{{ detailData.loadingTaxRate ? detailData.loadingTaxRate + '%' : '无' }}
              </span>
              <span v-if="detailData.isLoadSettlement == 1" style="padding-right: 10px">
                单价：{{ detailData.loadingPrice ? detailData.loadingPrice + '元' : '无' }}
              </span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">卸车费：</span>
              <span style="padding-right: 10px">{{ detailData.isUnload == 0 ? '有' : '无' }}</span>
              <span v-if="detailData.isUnloadSettlement == 1" style="padding-right: 10px"
                >单独结算</span
              >
              <span v-else style="padding-right: 10px">不单独结算</span>
              <span v-if="detailData.isUnloadSettlement == 1" style="padding-right: 10px">
                税率：{{ detailData.unloadTaxRate ? detailData.unloadTaxRate + '%' : '无' }}
              </span>
              <span v-if="detailData.isUnloadSettlement == 1" style="padding-right: 10px">
                单价：{{ detailData.unloadPrice ? detailData.unloadPrice + '元' : '无' }}
              </span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>补录合同</span>
          </div>
          <div class="operationTable">
            <el-table
              :data="detailData.contractData"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                fontsize: '12px',
                height: '40px',
                background: '#E8E8E8',
              }">
              <el-table-column
                type="index"
                label="序号"
                width="50"
                align="center"></el-table-column>
              <el-table-column
                property="codeNumber"
                label="合同编号"
                min-width="150"
                align="center" />
              <el-table-column
                property="contractName"
                label="合同名称"
                min-width="150"
                align="center" />
              <el-table-column
                property="typeName"
                label="合同类型"
                min-width="100"
                align="center" />
              <el-table-column property="rate" label="税率" min-width="150" align="center" />
              <el-table-column
                property="taxContractPrice"
                label="含税合同价"
                min-width="150"
                align="center" />
              <el-table-column
                property="contractPrice"
                label="不含税合同价"
                min-width="150"
                align="center" />
              <el-table-column
                property="startDate"
                label="开始日期"
                min-width="100"
                :formatter="getDate"
                align="center" />
              <el-table-column
                property="endDate"
                label="结束日期"
                min-width="100"
                :formatter="getDate"
                align="center" />
              <el-table-column width="200px" label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="deleteTableClick(scope.row.id)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>适配车型</span>
          </div>
          <div class="operationTable">
            <el-table
              :data="detailData.carModelList"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                fontsize: '12px',
                height: '40px',
                background: '#E8E8E8',
              }">
              <el-table-column label="序号" type="index" align="center" width="60px" />
              <el-table-column prop="brandName" label="品牌" align="center" />
              <el-table-column prop="modelName" label="型号" align="center" />
              <el-table-column prop="status" label="状态" align="center">
                <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table
              :data="detailData.operateRecordList"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                'font-size': '12px',
                height: '40px',
                background: '#E8E8E8',
              }">
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      center
      @close="dialogClose"
      :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="companyData" label-width="85px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" divStyle="margin-top: 10px">
            <el-row>
              <el-col v-if="editType === 0">
                <el-form-item
                  label="委托商："
                  style="margin-top: 10px; margin-bottom: 10px"
                  prop="name">
                  <el-select
                    v-model="companyData.name"
                    filterable
                    size="small"
                    style="width: 100%"
                    placeholder="请选择委托商"
                    value-key="id"
                    @change="nameChange">
                    <el-option
                      v-for="item in nameOption"
                      :key="item.id"
                      :label="item.customer_name"
                      :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="editType === 0">
                <el-form-item label="线路选择：" prop="line" style="margin-bottom: 10px">
                  <el-select
                    v-model="companyData.line"
                    @change="lineChange"
                    filterable
                    style="width: 100%"
                    size="small"
                    placeholder="请选择线路"
                    value-key="id">
                    <el-option
                      v-for="item in lineOption"
                      :key="item.id"
                      :label="item.line_name"
                      :value="item"></el-option>
                  </el-select>
                  <div v-if="lineData.line_name && lineData.line_name != ''">
                    <el-row
                      style="
                        color: rgb(153, 153, 153);
                        font-size: 12px;
                        line-height: 18px;
                        margin-bottom: 3px;
                      ">
                      <el-col v-if="!lineData.departure_port_id" :span="24"
                        >起始地：{{ lineData.start_address_name }}
                      </el-col>
                      <el-col v-else :span="24"
                        >起始地：{{ lineData.start_address_name }}【{{ lineData.departure_port }}】
                      </el-col>
                    </el-row>
                    <el-row style="color: rgb(153, 153, 153); font-size: 12px; line-height: 18px">
                      <el-col v-if="!lineData.arrive_port_id" :span="24">
                        终止地：{{ lineData.end_address_name }}
                      </el-col>
                      <el-col v-else :span="24"
                        >终止地：{{ lineData.end_address_name }}【{{ lineData.arrive_port }}】
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <!-- <el-form-item label="港口：" style="margin-top: 10px;margin-bottom: 10px" prop="name">
                  <el-select v-model="companyData.port" filterable size="mini" style="width:100%" placeholder="请选择港口" value-key="id" @change="nameChange">
                    <el-option v-for="item in portOption" :key="item.id" :label="item.supplier_name" :value="item"/>
                  </el-select>
                </el-form-item> -->
              </el-col>
              <el-col :class="{ mt10: editType === 1 }">
                <el-form-item label="适配车型：" style="margin-bottom: 10px" prop="model">
                  <cascader
                    ref="cascader"
                    :options="modelOption"
                    :props="{
                      value: 'id',
                      label: 'model',
                      children: 'carModel',
                      multiple: true,
                    }"
                    :filed="'model'"
                    @getValue="getValue" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="editType === 0">
                <el-form-item label="有效期始：" prop="start" style="margin-bottom: 20px">
                  <el-date-picker
                    v-model="companyData.start"
                    size="small"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效开始时间" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="editType === 0">
                <el-form-item label="结束日期：" prop="end">
                  <el-date-picker
                    v-model="companyData.end"
                    size="small"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效结束时间"
                    default-time="23:59:59"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border
            label="费用设置"
            divStyle="margin-top: 10px;padding:0 10px 10px"
            v-if="editType === 0">
            <el-row>
              <el-col>
                <el-form-item
                  label="装车费："
                  label-width="110px"
                  prop="isLoad"
                  style="margin-bottom: 3px; margin-top: 10px">
                  <el-radio-group v-model="companyData.isLoad">
                    <el-radio size="mini" :label="0">有</el-radio>
                    <el-radio size="mini" :label="1">无</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <div style="display: flex">
                  <el-form-item
                    v-if="companyData.isLoad == 0"
                    label="是否单独结算："
                    prop="isLoadSettlement"
                    label-width="110px"
                    style="margin-bottom: 3px; padding-right: 20px">
                    <el-radio-group v-model="companyData.isLoadSettlement">
                      <el-radio size="mini" :label="0">否</el-radio>
                      <el-radio size="mini" :label="1">是</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    v-if="companyData.isLoad == 0 && companyData.isLoadSettlement == 1"
                    prop="loadPrice"
                    class="specialItem">
                    <el-input
                      style="width: 140px; margin-right: 10px"
                      v-model="companyData.loadPrice"
                      onkeyup="this.value=this.value.replace(/^\D*([0-9]\d*\.?\d*)?.*$/,'$1')"
                      placeholder="请输入单价"
                      autocomplete="off"
                      size="mini">
                      <span slot="suffix" style="color: #999">| 元</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="companyData.isLoad == 0 && companyData.isLoadSettlement == 1"
                    prop="loadTaxRate"
                    class="specialItem">
                    <el-input
                      style="width: 140px"
                      v-model="companyData.loadTaxRate"
                      onkeyup="this.value=this.value.replace(/^\D*([0-9]\d*\.?\d*)?.*$/,'$1')"
                      placeholder="请输入税率"
                      autocomplete="off"
                      size="mini">
                      <span slot="suffix" style="color: #999">| %</span>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col>
                <el-form-item
                  label="卸车费："
                  label-width="110px"
                  prop="isUnload"
                  style="margin-bottom: 3px">
                  <el-radio-group v-model="companyData.isUnload">
                    <el-radio size="mini" :label="0">有</el-radio>
                    <el-radio size="mini" :label="1">无</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <div style="display: flex">
                  <el-form-item
                    v-if="companyData.isUnload == 0"
                    label="是否单独结算："
                    prop="isUnloadSettlement"
                    label-width="110px"
                    style="margin-bottom: 3px; padding-right: 20px">
                    <el-radio-group v-model="companyData.isUnloadSettlement">
                      <el-radio size="mini" :label="0">否</el-radio>
                      <el-radio size="mini" :label="1">是</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    v-if="companyData.isUnload == 0 && companyData.isUnloadSettlement == 1"
                    prop="unloadPrice"
                    class="specialItem">
                    <el-input
                      style="width: 140px; margin-right: 10px"
                      v-model="companyData.unloadPrice"
                      onkeyup="this.value=this.value.replace(/^\D*([0-9]\d*\.?\d*)?.*$/,'$1')"
                      placeholder="请输入单价"
                      autocomplete="off"
                      size="mini">
                      <span slot="suffix" style="color: #999">| 元</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="companyData.isUnload == 0 && companyData.isUnloadSettlement == 1"
                    prop="unloadTaxRate"
                    class="specialItem">
                    <el-input
                      style="width: 140px"
                      v-model="companyData.unloadTaxRate"
                      onkeyup="this.value=this.value.replace(/^\D*([0-9]\d*\.?\d*)?.*$/,'$1')"
                      placeholder="请输入税率"
                      autocomplete="off"
                      size="mini">
                      <span slot="suffix" style="color: #999">| %</span>
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="合同设置" style='padding: 29px 20px'>
            <el-row>
              <el-col :span='24'>
                <el-form-item label='合同：' prop='contract'>
                  <el-select v-model="companyData.contract" filterable style="width: 100%" size="small"
                    placeholder="请选择合同" value-key="id" @change="getContract">
                    <el-option
                      v-for="item in contractOption" :key="item.id" :label="item.name"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick"
              >确定
            </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="选择适配车型"
      :visible.sync="carVisible"
      width="600px"
      @close="carClose"
      center
      :close-on-click-modal="false"
      top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div
              class="carContainerTitleContentItem"
              v-for="(item, index) in selectCar"
              :key="index"
              @click="selectRemove(item)">
              {{ item.name }}<i class="el-icon-close" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div
              class="carContainerTitleContentItem"
              v-for="(item, index) in selectBrand"
              :key="index">
              <p @click="brandClick(item.id)">{{ item.name }}&nbsp;</p>
              <i class="el-icon-plus" @click="brandAdd(item)" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div
              class="carContainerTitleContentItem"
              v-for="(item, index) in selectModel"
              :key="index"
              @click="modelAdd(item)">
              <p>{{ item.name }}</p>
              <i class="el-icon-plus" />
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="mini" @click="carAddClick">确定</el-button>
          <el-button class="resetBtn" size="mini" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--补录合同-->
    <el-dialog
      title="补录合同"
      :visible.sync="contractVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px"
      @close="cancel">
      <div-border label="价格设置">
        <div class="nav" style="margin-top: 10px">
          <div class="navContainer" style="width: 300px">
            <p style="width: 100px">不含税金额：</p>
            <el-input
              v-model="condition.price"
              size="mini"
              style="width: 150px"
              placeholder="请输入不含税金额" />
          </div>
          <div class="navContainer">
            <p>含税金额：</p>
            <el-input
              v-model="condition.taxPrice"
              size="mini"
              style="width: 150px"
              placeholder="请输入含税金额" />
          </div>
          <div class="navBtn" style="width: 200px; margin: -30px 555px 15px">
            <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
            <el-button size="small" class="resetBtn" @click="cancel">取消</el-button>
          </div>
        </div>
      </div-border>
      <div-border label="选择合同">
        <el-table
          :data="contractTableData"
          highlight-current-row
          border
          ref="contractTable"
          @current-change="contractChange"
          v-loading="contractLoad"
          style="margin-top: 10px"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-weight': '700',
            padding: '0px',
            'font-size': '13px',
            height: '35px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
          <el-table-column type="index" width="50" />
          <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
          <el-table-column
            property="contractName"
            label="合同名称"
            min-width="150"
            align="center" />
          <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
          <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
          <el-table-column
            property="startDate"
            label="开始日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
          <el-table-column
            property="endDate"
            label="结束日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
        </el-table>
        <div style="margin-top: 20px">
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="addContractSizeChange"
            @current-change="addContractCurrentChange"
            :current-page.sync="page"
            :page-size="row" />
        </div>
      </div-border>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import cascader from '@/components/cascader';
  import {
    addConsignorOther,
    consignorOtherList,
    reviseConsignorOther,
    getCarSerieList,
    getCarSerDetail,
    changeEnableDisable,
    deleteConsignorOther,
    getContractInfo,
    deleteContractInfo,
    getContractPageList,
    addContract,
  } from '@/service/financial';
  import { customerInfoSelectList } from '@/service/basicfile';
  import { publicSelectLine } from '@/service/vehiclelog';
  import { baseUrl } from '@/config/env';
  import { getImport, getImportUrl } from '@/service/getIP';
  import {contractPageList, contractSelectPageList} from "@/service/contract";
  export default {
    components: {
      steps,
      divBorder,
      cascader,
    },
    data() {
      const validateOrg = (rule, value, callback) => {
        console.log(this.companyData.model);
        if (this.companyData.model.length === 0) {
          callback(new Error('请选择适配车型'));
        } else {
          callback();
        }
      };
      return {
        entrustIpt: '',
        portIpt: '',
        endport: '',
        modelIpt: '',
        createByName: '',
        stateIpt: '',
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待生效',
          },
          {
            value: 1,
            label: '生效中',
          },
          {
            value: 2,
            label: '已失效',
          },
        ],
        contractVisible: false,
        contractTableData: [],
        condition: {
          price: '',
          taxPrice: '',
        },
        contractLoad: false,
        //总数据条数
        total: 0,
        //当前页数
        page: 1,
        //每页显示多少条数据
        row: 10,
        selectContract: {
          id: '',
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        size: 10,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        operationData: [],
        dialogVisible: false,
        dialogTitle: '',
        addLoad: false,
        changeLoad: false,
        nameOption: [],
        portOption: [],
        // 线路
        lineOption: [],
        lineData: {},
        modelOption: [],
        contractOption: [],
        modelMap: new Map(),
        brandMap: new Map(),
        companyData: {},
        rules: {
          name: [
            {
              required: true,
              message: '请选择委托商',
              trigger: 'change',
            },
          ],
          line: [
            {
              required: true,
              message: '请选择线路',
              trigger: 'change',
            },
          ],
          model: [
            {
              required: true,
              trigger: 'blur',
              type: 'array',
              validator: validateOrg,
            },
          ],
          start: [
            {
              required: true,
              message: '请选择有效开始时间',
              trigger: 'change',
            },
          ],
          end: [
            {
              required: true,
              message: '请选择有效结束时间',
              trigger: 'change',
            },
          ],
          isLoad: [
            {
              required: true,
              message: '请选择装车费',
              trigger: 'change',
            },
          ],
          isLoadSettlement: [
            {
              required: true,
              message: '选择是否单独结算',
              trigger: 'change',
            },
          ],
          loadPrice: [
            {
              required: true,
              message: '请输入单价',
              trigger: 'change',
            },
          ],
          loadTaxRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'change',
            },
          ],
          isUnload: [
            {
              required: true,
              message: '请选择卸车费',
              trigger: 'change',
            },
          ],
          isUnloadSettlement: [
            {
              required: true,
              message: '选择是否单独结算',
              trigger: 'change',
            },
          ],
          unloadPrice: [
            {
              required: true,
              message: '请输入单价',
              trigger: 'change',
            },
          ],
          unloadTaxRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'change',
            },
          ],
          contract: [
            {
              required: true,
              message: '请选择合同',
              trigger: 'change',
            },
          ],
        },
        carVisible: false,
        selectedCar: [],
        selectCar: [],
        brands: [],
        models: [],
        brands2: [],
        models2: [],
        selectBrand: [],
        selectModel: [],
        allCar: [],
        allModel: [],
        editType: 0,
        checkTableData: [],

        importLoading: false,
        uploadUrl: '', //导入地址
        uploadData: { mFile: '' },
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待生效';
            case 1:
              return '生效中';
            case 2:
              return '已失效';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
    },
    filters: {
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    async mounted() {
      //  await this._consignorOtherList();
      this.uploadUrl = getImportUrl('/price/loadUnload/batchImport');
    },
    methods: {
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0)
          return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认批量启用当前选中港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            let res = await changeEnableDisable({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._consignorOtherList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 分页查询
      async _consignorOtherList() {
        this.tableLoad = true;
        const res = await consignorOtherList({
          customerName: this.entrustIpt,
          startPort: this.portIpt,
          endPort: this.endport,
          customerCarName: this.modelIpt,
          status: this.stateIpt,
          createByName: this.createByName,
          rows: this.size,
          page: this.page,
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._consignorOtherList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._consignorOtherList();
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._consignorOtherList();
      },
      // 重置
      resetBtn() {
        this.entrustIpt = '';
        this.portIpt = '';
        this.endport = '';
        this.modelIpt = '';
        this.stateIpt = '';
        this.createByName = ''
      },
      // 获取 线路、委托商
      async _oherList() {
        // let res =await supplierPublicSelectPort()
        // if (res.status !==0) return this.$message.error(res.message);
        // this.portOption = res.data
        // 线路
        let res = await publicSelectLine({ type: 2 });
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineOption = res.data;
        // 委托商
        const res3 = await customerInfoSelectList();
        if (res3.status !== 0) this.$message.error(res3.message);
        this.nameOption = res3.data;
      },
      // 获取品牌型号
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item.carModel.length != 0;
        });
        this.modelOption = this.modelOption.map(item => {
          item.carModel.forEach((item, index) => {
            this.modelMap.set(item.brand_id, item.brand_name);
            this.brandMap.set(item.id, item.model);
          });
          return {
            ...item,
            model: item.brand,
          };
        });
        this.modelOption.unshift({
          model: '全选',
          id: '全选',
        });
        console.log(this.modelOption);
      },
      // 线路改变
      lineChange(val) {
        this.lineData = val;
      },
      bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        // 减小于0 date<date1
        return date.getTime() - date1.getTime() < 0;
      },
      // 新增/修改 -- 取消(关闭弹窗)
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.$refs.cascader.value = [];
        this.dialogVisible = false;
      },
      // 新增/修改 -- 确认
      addClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (!this.bjDate(this.companyData.start, this.companyData.end))
              return this.$message.warning('结束时间不得小于开始时间！');
            // if(this.companyData.isLoad==1&&this.companyData.isUnload==1) {
            //   return this.$message.warning('装车费、卸车费至少要有一个！');
            // }
            if (
              this.companyData.isLoad === 0 &&
              this.companyData.isLoadSettlement === 0 &&
              this.companyData.isUnload === 0 &&
              this.companyData.isUnloadSettlement === 0
            ) {
              return this.$message.error('系统默认装车费、卸车费有并且都不单独结算！');
            }
            this.addLoad = true;
            const obj = {
              contractId: this.companyData.contract.id,
              customerId: this.companyData.name,
              // portId:this.companyData.port.id,
              lineId: this.companyData.line.id,
              startDate: this.companyData.start,
              endDate: this.companyData.end,
              // 装车费
              isLoading: this.companyData.isLoad,
              isLoadSettlement: this.companyData.isLoadSettlement,
              loadingPrice: this.companyData.loadPrice,
              loadingTaxRate: this.companyData.loadTaxRate, // 税率
              // 卸车费
              isUnload: this.companyData.isUnload,
              isUnloadSettlement: this.companyData.isUnloadSettlement,
              unloadPrice: this.companyData.unloadPrice,
              unloadTaxRate: this.companyData.unloadTaxRate, // 税率
              // brandId:str,
              // modelId:str2,
              carModelList: this.companyData.model.map(item => {
                return {
                  brandId: item[0],
                  brandName: this.modelMap.get(item[0]),
                  modelId: item[1],
                  modelName: this.brandMap.get(item[1]),
                };
              }),
            };
            if (this.dialogTitle !== '添加港口作业单价') {
              obj.id = this.companyData.id;
              obj.status = this.companyData.status;
            }
            // return false
            const res =
              this.dialogTitle == '添加港口作业单价'
                ? await addConsignorOther(obj)
                : await reviseConsignorOther(obj);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            await this._consignorOtherList();
          } else {
            return false;
          }
        });
      },
      // 委托商改变
      nameChange() {
        this.companyData.contract = ''
        this._contractPageList()
      },
      getContract(){
        this.$forceUpdate()
      },
      // 选择合同 —— 查询
      async _contractPageList() {
        let obj = {
          id: this.companyData.name,
        };
        let res = await contractSelectPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractOption = res.data;
      },
      // 选择适配车型 -- 已选择车型
      selectRemove(item) {
        this.selectCar.splice(this.selectCar.indexOf(item), 1);
        if (this.brands.indexOf(item) !== -1) {
          this.brands.splice(this.brands.indexOf(item), 1);
        } else {
          this.models.splice(this.models.indexOf(item), 1);
        }
      },
      // 选择适配车型 -- 选择品牌
      brandAdd(item) {
        if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
        let arr = [];
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === item.id) {
            arr = this.allCar[i].carModel;
            break;
          }
        }
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.selectCar.length; j++) {
            if (arr[i].id === this.selectCar[j].id) {
              this.selectCar.splice(j, 1);
              j--;
            }
          }
        }
        this.selectCar.push(item);
        this.brands.push(item);
      },
      brandClick(id) {
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === id) {
            this.selectModel = this.allCar[i].carModel.map(item => {
              return {
                id: item.id,
                name: item.brand_name,
                brandId: item.brand_id,
              };
            });
            break;
          }
        }
      },
      // 选择适配车型 -- 选择型号
      modelAdd(item) {
        for (let i = 0; i < this.selectCar.length; i++) {
          if (this.selectCar[i].id === item.brandId) {
            return this.$message.warning('上方已选择该品牌的全部车型！');
          } else if (this.selectCar[i].id === item.id)
            return this.$message.warning('已选择该车型！');
        }
        this.selectCar.push(item);
        this.models.push(item);
      },
      // 选择适配车型 -- 确认
      carAddClick() {
        this.carVisible = false;
        this.selectedCar = [...this.selectCar];
        this.brands2 = [...this.brands];
        this.models2 = [...this.models];
      },
      // 选择适配车型 -- 取消
      carClose() {
        this.carVisible = false;
      },
      /**
       *  补录合同
       */
      recordBtn(row) {
        this.condition.id = row.id;
        this.companyId = row.customerId;
        this.contractPrice = row.contractPrice;
        this.preparePrice = row.preparePrice;
        this.getContractPage();
      },
      //查询
      async getContractPage() {
        let obj = {
          id: this.condition.id,
          companyId: this.condition.companyId,
          contractPrice: this.condition.contractPrice ? this.condition.contractPrice : '',
          preparePrice: this.condition.preparePrice ? this.condition.preparePrice : '',
          page: this.page,
          row: this.row,
        };
        this.contractLoad = true;
        let res = await getContractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          this.contractVisible = false;
        } else {
          this.contractVisible = true;
        }
        this.contractTableData = res.data.records;
        this.total = res.data.total;
      },
      async contractConfirm() {
        if (!this.condition.price || this.condition.price === '') {
          return this.$message.warning('请输入不含税金额！');
        }
        if (!this.condition.taxPrice || this.condition.taxPrice === '') {
          return this.$message.warning('请输入含税金额！');
        }
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        this.selectContract = '';
        let obj = {
          type: 2,
          ...this.condition,
          startDate: this.contractTableData[0].startDate ? this.contractTableData[0].startDate : '',
          endDate: this.contractTableData[0].endDate ? this.contractTableData[0].endDate : '',
        };
        const res = await addContract(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.contractVisible = false;
      },
      cancel() {
        this.condition.price = '';
        this.condition.taxPrice = '';
        this.contractVisible = false;
      },
      addContractSizeChange(rows) {
        this.condition.row = rows;
        this.getContractPage();
      },
      addContractCurrentChange(page) {
        this.condition.page = page;
        this.getContractPage();
      },
      // 合同编号 —— 选中数据
      contractChange(val) {
        this.selectContract = val;
      },
      // 删除
      deleteClick(row) {
        this.$confirm('确认删除当前港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteConsignorOther(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._consignorOtherList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        // console.log(this.checkTableData);
        if (this.checkTableData.length > 0) {
          this.$confirm('确认删除当前选中港口作业单价设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData.id + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              const res = await deleteConsignorOther(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = []
              await this._consignorOtherList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      // 详情
      async detailClick(id) {
        const res = await getCarSerDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        const res1 = await getContractInfo(id);
        if (res1.status !== 0) return this.$message.error(res1.message);
        this.detailData.contractData = res1.data;
        this.detailDialogVisible = true;
      },
      // 修改
      async changeClick(id, type) {
        this.editType = type;
        await this._oherList();
        await this._getCarSerieList();
        this.dialogTitle = '修改港口作业单价';
        const res = await getCarSerDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        let name = '';
        if (res.data.contractCode != null && res.data.contractCode !== '') {
          name = res.data.contractCode + '-' + res.data.contractName
        } else {
          name = null;
        }
        this.companyData = {
          ...res.data,
          name: res.data.customerId,
          // port: {id:res.data.portId, supplier_name:res.data.portName},
          line: {
            id: res.data.lineId,
            line_name: res.data.lineName,
          },
          contract:  {
            id: res.data.contractId,
            name:name
          },
          model:
            res.data.carModelList.length > 0
              ? res.data.carModelList.map(r => {
                  return [r.brandId, r.modelId];
                })
              : [],
          start: res.data.startDate,
          end: res.data.endDate,
          // 装车费
          isLoad: res.data.isLoading,
          loadPrice: res.data.loadingPrice,
          loadTaxRate: res.data.loadingTaxRate,
          // 卸车费
          isUnload: res.data.isUnload,
          isSettlement: res.data.isUnloadSettlement,
          unloadPrice: res.data.unloadPrice,
          unloadTaxRate: res.data.unloadTaxRate,
        };
        this.lineData = {
          id: res.data.lineId,
          line_name: res.data.lineName,
          departure_port_id: res.data.startPortId,
          departure_port: res.data.startPort,
          start_address_name: res.data.startAddressName,
          arrive_port_id: res.data.endPortId,
          arrive_port: res.data.endPort,
          end_address_name: res.data.endAddressName,
        };
        let obj = {
          id: this.companyData.name,
        };
        let data = await contractSelectPageList(obj);
        if (data.status !== 0) return this.$message.error(data.message);
        this.contractOption = data.data;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.cascader.value = this.companyData.model;
        });
      },
      // 新增
      addBtn() {
        this.editType = 0;
        this.dialogTitle = '添加港口作业单价';
        this.companyData = {
          isLoad: 0,
          isLoadSettlement: 0,
          isUnload: 0,
          isUnloadSettlement: 0,
          model: [],
        };
        this.lineData = {};
        this.dialogVisible = true;
        // this.$refs.ruleForm.resetFields();
        this._oherList();
        this._getCarSerieList();
      },
      // 启用
      enableClick(row) {
        this.$confirm('确认启用当前港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await changeEnableDisable({
              id: row.id,
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._consignorOtherList();
          })
          .catch(() => {});
      },
      // 停用
      disableClick(row) {
        this.$confirm('确认停用当前港口作业单价设置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await changeEnableDisable({
              id: row.id,
              status: 2,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._consignorOtherList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStops() {
        // console.log(this.checkTableData);
        if (this.checkTableData.length > 0) {
          this.$confirm('确认停用当前选择的港口作业单价设置吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData.id + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              const res = await changeEnableDisable({
                id: ids,
                status: 2,
              });
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              await this._consignorOtherList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择停用的港口作业单价设置！',
            type: 'warning',
          });
        }
      },
      getValue(filed, data, isAll) {
        let subData = JSON.parse(JSON.stringify(data));
        isAll ? subData.shift() : '';
        this.companyData[filed] = subData;
        this.$refs.ruleForm.validateField(['model'], () => {});
      },
      //详情-补录合同-删除
      deleteTableClick(id) {
        this.$confirm('确认删除当前合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteContractInfo(id);
            if (res.status === 0) {
              this.$message.success(res.message);
              await this.detailClick();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {});
        this.detailData.contractData.splice(index, 1);
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/price/loadUnload/export?access_token=${token}&customerName=${this.entrustIpt}&startPort=${this.portIpt}&endPort=${this.endport}&customerCarName=${this.modelIpt}&status=${this.stateIpt}`;
        window.exportExcelGet('/platform/price/loadUnload/export', `customerName=${this.entrustIpt}&startPort=${this.portIpt}&endPort=${this.endport}&customerCarName=${this.modelIpt}&status=${this.stateIpt}`);
      },
      //模板下载
      download() {
        window.location.href = '/file/港口作业单价设置信息导入模板.xls';
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._consignorOtherList();
          },
        });
      },
      beforeUpload(file) {
        let len = file.name.split('.').length;
        if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        margin-top: 10px;
        width: 100%;

        .table-btn {
          line-height: 22px;
          color: #3388ff;
          cursor: pointer;
        }

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px;
      max-height: 70vh;
      overflow: auto;

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-form-item.specialItem {
      margin-bottom: 0px !important;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-form-item__error {
      margin-top: -3px;
      padding-top: 0px;
    }
  }
  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }
</style>
